/**
 * ion-content 组件
 * @author xierenyuan@qq.com
 */
import Content from './src/content.vue';

Content.install = function(Vue) {
    Vue.component(Content.name, Content);
};

export default Content;


// WEBPACK FOOTER //
// ./src/components/content/index.js